document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        $(document).on('Searchanise.ResultsUpdated', function (event, container) {
            setTimeout(function() {
                let productData = $(this).data('snize_item_data');
                let productsInARow = Math.floor($('#snize-search-results-grid-mode').width() / $('.snize-product').width());
                let rowNumbers = Math.ceil($('.snize-product').length / productsInARow);
                for (let r = 1; r < rowNumbers; r++) {
                    let titleHeights = [];
                    let productsIdxs = [];
                    let productIdxMax = r * productsInARow;
                    let productIdxMin = productIdxMax - productsInARow;
                    for (let p = productIdxMin; p < productIdxMax; p++) {
                        titleHeights.push($($('.snize-product', container)[p]).find('.snize-title').height());
                        productsIdxs.push(p);
                    }
                    if (!titleHeights.every((val, i, arr) => val == arr[0])) {
                        let heightToFix = Math.max(...titleHeights);
                        for (let idx of productsIdxs) {
                            $($('.snize-product', container)[idx]).find('.snize-title').height(heightToFix);
                        }
                    }
                }
            }, 500);
        });
    })(window.Searchanise.$);
});